import { cn } from 'cn';

/**
 * The Tekansa Connect logo. Light and dark versions (dark has white "Tekansa" text);
 * `compact` shows only the mark. Source: public/logo.png (trimmed copies in public/).
 */
export function Wordmark({
  className,
  compact = false,
}: {
  className?: string;
  compact?: boolean;
}) {
  if (compact) {
    return (
      <img
        src="/logo-mark.png"
        alt="Tekansa Connect"
        className={cn('size-8 select-none', className)}
      />
    );
  }
  return (
    <span className={cn('inline-flex items-center select-none', className)}>
      <img src="/logo-light.png" alt="Tekansa Connect" className="h-9 w-auto dark:hidden" />
      <img src="/logo-dark.png" alt="Tekansa Connect" className="hidden h-9 w-auto dark:block" />
    </span>
  );
}
